import { Phone, Mail } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#FBF9F5] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <Overline>Contact Us</Overline>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-[#0B192C] leading-[1.1]">
            Let&rsquo;s Work Together
          </h2>
          <p data-testid="contact-intro-text" className="mt-6 text-base sm:text-lg text-[#475569] leading-relaxed">
            Have an import, export, logistics, warehousing or trade requirement? Get in touch with
            us.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-5">
            <a
              data-testid="contact-phone-link"
              href={CONTACT.phoneHref}
              className="group flex items-center gap-3.5 rounded-full bg-white border border-[#E2E8F0]/80 px-7 py-4 transition-all duration-300 hover:border-[#C5A059]/50 hover:-translate-y-0.5"
            >
              <span className="h-10 w-10 rounded-full bg-[#E4EFF8] text-[#0B192C] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#C5A059] group-hover:text-white">
                <Phone className="w-5 h-5" strokeWidth={1.8} />
              </span>
              <span data-testid="contact-phone-text" className="font-medium text-[#0B192C]">{CONTACT.phone}</span>
            </a>
            <a
              data-testid="contact-email-link"
              href={`mailto:${CONTACT.email}`}
              className="group flex items-center gap-3.5 rounded-full bg-white border border-[#E2E8F0]/80 px-7 py-4 transition-all duration-300 hover:border-[#C5A059]/50 hover:-translate-y-0.5"
            >
              <span className="h-10 w-10 rounded-full bg-[#E4EFF8] text-[#0B192C] flex items-center justify-center transition-colors duration-300 group-hover:bg-[#C5A059] group-hover:text-white">
                <Mail className="w-5 h-5" strokeWidth={1.8} />
              </span>
              <span data-testid="contact-email-text" className="font-medium text-[#0B192C]">{CONTACT.email}</span>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
